// src/services/geo.service.js
import { api } from './api';

class GeoService {
    // ─── Office Locations ────────────────────────────────────────────
    async getOfficeLocations() {
        const response = await api.get('/api/geo/office-locations');
        return response.data;
    }

    async createOfficeLocation(data) {
        const response = await api.post('/api/geo/office-locations', data);
        return response.data;
    }

    async updateOfficeLocation(id, data) {
        const response = await api.put(`/api/geo/office-locations/${id}`, data);
        return response.data;
    }

    async deleteOfficeLocation(id) {
        const response = await api.delete(`/api/geo/office-locations/${id}`);
        return response.data;
    }

    // ─── Geofence Verification ───────────────────────────────────────
    async verifyLocation(latitude, longitude) {
        const response = await api.post('/api/geo/verify', { latitude, longitude });
        return response.data;
    }

    // ─── Punch Map ───────────────────────────────────────────────────
    async getPunchMap(date = null) {
        const params = date ? `?date=${date}` : '';
        const response = await api.get(`/api/geo/punch-map${params}`);
        return response.data;
    }

    // ─── Punch History ───────────────────────────────────────────────
    async getPunchHistory(params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/geo/punch-history?${query}`);
        return response.data;
    }

    // ─── Detect IP (for easy network setup) ──────────────────────────
    async detectMyIp() {
        const response = await api.get('/api/geo/detect-ip');
        return response.data;
    }

    // ─── Office Networks (IP-based verification) ────────────────────
    async getOfficeNetworks() {
        const response = await api.get('/api/geo/office-networks');
        return response.data;
    }

    async createOfficeNetwork(data) {
        const response = await api.post('/api/geo/office-networks', data);
        return response.data;
    }

    async updateOfficeNetwork(id, data) {
        const response = await api.put(`/api/geo/office-networks/${id}`, data);
        return response.data;
    }

    async deleteOfficeNetwork(id) {
        const response = await api.delete(`/api/geo/office-networks/${id}`);
        return response.data;
    }

    // ─── Geo Verification Settings ──────────────────────────────────
    async getGeoSettings() {
        const response = await api.get('/api/geo/settings');
        return response.data;
    }

    async updateGeoSettings(settings) {
        const response = await api.put('/api/geo/settings', settings);
        return response.data;
    }
}

const geoService = new GeoService();
export default geoService;
